App.load(() => {
    document
        .querySelectorAll('.js-wp-toLoad').forEach(function (element) {
        const observer = new IntersectionObserver(([e], o) => {
            if (e.intersectionRatio) {
                e.target.classList.remove('js-wp-toLoad');
                e.target.classList.add('js-wp-loaded');
                o.unobserve(e.target);
            }
        }, {threshold: element.dataset.offset || 0});
        observer.observe(element);
    })
    ;
})
